import CompanyMerge from './CompanyMerge';
export default CompanyMerge;